exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page[data-v-49fb74ea]{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center;display:flex;align-items:center;justify-content:center;padding:24px;background:#393259;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49fb74ea","scoped":true,"sourceMap":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/NotFound.vue
// module id = 537
// module chunks = 0